import { Component } from '@angular/core';
import { CaptureHistoryItemTypeBaseComponent } from '../capture-history-item-type-base/capture-history-item-type-base.component';
import { CaptureHistoryItemTitleComponent } from '../capture-history-item-title/capture-history-item-title.component';
import { CaptureHistoryItemBodyComponent } from '../capture-history-item-body/capture-history-item-body.component';

@Component({
    selector: 'app-capture-history-item-type-referral-match-verification-submitted',
    templateUrl: './capture-history-item-type-referral-match-verification-submitted.component.html',
    imports: [CaptureHistoryItemTitleComponent, CaptureHistoryItemBodyComponent]
})
export class CaptureHistoryItemTypeReferralMatchVerificationSubmittedComponent
       extends CaptureHistoryItemTypeBaseComponent {
  get title() {
    return 'Referral Validation Submitted';
  }
}
